import { Grid, Typography, CircularProgress, Link } from '@material-ui/core';
import { SyntheticEvent } from 'react';
import { truncate, withTooltip } from '../../core/format';
import { Page } from '../../core/page';
import { orange } from '../../core/theme';
import React from 'react';
import create from 'zustand';


export interface FieldValueProps {
  label: string;
  value: any;
  row?: boolean;
  spacing?: number;
  containerStyle?: object;
  itemStyle?: object;
  valueStyle?: object;
  labelStyle?: object;
  wrap?: boolean;
}

const space = '\u00A0';
export function FieldValue(props: FieldValueProps) {
  const {
    label,
    value,
    row,
    spacing,
    containerStyle,
    itemStyle,
    valueStyle,
    wrap,
  } = props;
  const opt: any = row
    ? {
        direction: 'row',
        wrap: 'nowrap',
        spacing: spacing || 2,
        alignItems: 'flex-end',
      }
    : {
        direction: 'column',
        wrap: 'nowrap',
        spacing: spacing || 0,
        alignItems: 'flex-start',
      };

  const cStyle: any = { ...{ width: row ? '100%' : null }, ...containerStyle };
  const iStyle: any = { ...{ width: row ? '100%' : null }, ...itemStyle };
  const vStyle: any = {
    ...{
      whiteSpace: wrap ? undefined : 'nowrap',
      textAlign: row ? 'right' : undefined,
    },
    ...valueStyle,
  };
  return (
    <Grid container item {...opt} style={cStyle} id={label ? label : value}>
      <Grid item style={iStyle}>
        <Typography
          style={{ whiteSpace: 'nowrap' }}
          variant="body2"
          color="textSecondary"
        >
          {label}
        </Typography>
      </Grid>
      <Grid item style={iStyle}>
        <Typography color="textPrimary" style={vStyle}>
          {value || space}
        </Typography>
      </Grid>
    </Grid>
  );
}

export function FieldValueProductivity(props: FieldValueProps) {
  const {
    label,
    value,
    row,
    spacing,
    containerStyle,
    itemStyle,
    valueStyle,
    labelStyle,
    wrap,
  } = props;
  const opt: any = row
    ? {
        direction: 'row',
        wrap: 'nowrap',
        spacing: spacing || 2,
        alignItems: 'flex-end',
      }
    : {
        direction: 'column',
        wrap: 'nowrap',
        spacing: spacing || 0,
        alignItems: 'flex-start',
      };

  const cStyle: any = { ...{ width: row ? '100%' : null }, ...containerStyle };
  const iStyle: any = { ...{ width: row ? '100%' : null }, ...itemStyle };
  const vStyle: any = {
    ...{
      whiteSpace: wrap ? undefined : 'nowrap',
      textAlign: row ? 'right' : undefined,
    },
    ...valueStyle,
  };
  return (
    <Grid container item {...opt} style={cStyle} id={label ? label : value}>
      <Grid item style={labelStyle}>
        <Typography
          style={labelStyle ? labelStyle : { whiteSpace: 'nowrap' }}
          variant="body2"
          color="textSecondary"
        >
          {label}
        </Typography>
      </Grid>
      <Grid item style={vStyle}>
        <Typography color="textPrimary" style={vStyle}>
          {value || space}
        </Typography>
      </Grid>
    </Grid>
  );
}

export const loadingPage = create(() => ({
  show: false
}));

export function EmptyLoadingPage({absolute}: {absolute?:boolean}) {
  const show = loadingPage(s => s.show);
  return show &&  (
    <Grid
      container
      style={{ width: '100vw', height: '100vh', position :  absolute ? 'absolute' : undefined}}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>
        <CircularProgress color="primary" />
      </Grid>
    </Grid>
  );
}

export function MessagePage({ header, message }) {
  return (
    <Page
      drawerWidth={400}
      drawerOpen={true}
      mainHeader={header}
      main={
        <Grid
          container
          style={{ width: '100%', height: '83vh' }}
          justify="center"
          alignItems="center"
        >
          <Grid item>
            <Typography
              style={{ whiteSpace: 'nowrap' }}
              variant="h5"
              color="textSecondary"
            >
              {message}
            </Typography>
          </Grid>
        </Grid>
      }
    />
  );
}

type LinkButtonProps = {
  label: string;
  onClick?: (e?: SyntheticEvent) => void;
  color?: string;
  width?: any;
  style?: React.CSSProperties;
  id?: string;
  dataName?:string;
};
export function LinkButton(props: LinkButtonProps) {
  const { label, color, onClick, width, id, dataName } = props;
  const linkColor: any = color || orange;

  const onLinkClick = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  };
  const style = width ? truncate(width) : {};
  const component = (
    <Link
      id={id}
      data-name={dataName}
      onClick={onLinkClick}
      href="#"
      underline="always"
      style={{
        ...style,
        ...{ color: linkColor, whiteSpace: 'nowrap' },
        ...props.style,
      }}
    >
      {label}
    </Link>
  );

  return width ? withTooltip(label, component, 'bottom') : component;
}
